import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getTipSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.TIP.GET, null, true);
}

export function* insertUpdateTipSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TIP.INSERT_UPDATE, action.payload, true);
}
